/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const StarHalf = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M12.713 1.51283L15.0415 8.5H22.2515C22.9339 8.5 23.2454 9.3235 22.7845 9.77851L22.7053 9.84712L16.8865 14.269L19.4705 21.8106C19.6988 22.4769 18.9741 23.0426 18.3937 22.7083L18.3119 22.6544L12.0005 17.936L5.69102 22.6544C5.12688 23.0761 4.36613 22.56 4.50617 21.905L4.53242 21.8106L7.11546 14.269L1.29765 9.84712C0.754327 9.4342 1.00458 8.59005 1.64685 8.50667L1.75146 8.5H8.96046L11.2899 1.51283C11.5179 0.829057 12.485 0.829057 12.713 1.51283ZM12.0015 4.122V16.25C12.1243 16.25 12.2472 16.2801 12.3584 16.3403L12.4506 16.3993L17.2635 19.998L15.292 14.2431C15.1988 13.9712 15.2699 13.6734 15.4676 13.4732L15.5476 13.4029L20.0235 10H14.5015C14.2145 10 13.9562 9.83678 13.8306 9.58542L13.7899 9.48717L12.0015 4.122Z"
                        fill={color}
                    />
                </svg>
        );
    };
